import {canonicalIntent} from '../workspace/recipientNeededIntent.js'
// Confirm staging before a proof-draft request. This receipt is an optimistic
// identity/version token, not authority: the backend rereads canonical copy.
// This cache lives only in the actual CTC component. A failed/unknown draft does
// not invalidate its staged version, and an identical retry must not restage.
export async function stageChampionCampaign({stage,payload,cache}){
  const signature=JSON.stringify(payload)
  if(cache?.has(signature))return cache.get(signature)
  const result=await stage(payload)
  if(result?.ok!==true||result.status!==(payload.recipientMode==='recipient-needed'?'needs_recipient':'staged')||typeof result.campaignId!=='string'||!result.campaignId.trim()||!Number.isSafeInteger(result.version)||result.version<1)throw Error('Campaign staging was not confirmed. No mailbox draft was requested.')
  if(payload.recipientMode==='recipient-needed'&&(result.recipientMode!=='recipient-needed'||result.recipientStatus!=='needed'||result.recipients!==0||canonicalIntent(result.recipientNeededIntent)!==canonicalIntent(payload.recipientNeededIntent)))throw Error('Recipient-needed staging evidence changed.')
  const receipt={required:true,campaignId:result.campaignId,version:result.version,
    ...(result.selectionProtocol==='selected-coach-v1'?{selectionProtocol:result.selectionProtocol,selectedCoach:result.selectedCoach,requestId:result.requestId}:{})}
  cache?.set(signature,receipt)
  return receipt
}
export function campaignDraftMarker(staged,proof){
  if(!proof)return {}
  if(staged?.required!==true||!staged.campaignId||!Number.isSafeInteger(staged.version))throw Error('Confirm the current campaign stage before drafting its artwork.')
  return {campaignId:staged.campaignId,campaignBinding:staged}
}
